import { useEffect, useState, useContext } from 'react'
import { Link, useLocation } from "react-router-dom";
import config from "../config";
import axios from 'axios';
import { UserContext } from './MyContext';
import { BiSolidFactory } from "react-icons/bi";
import { FaBars, FaChartLine, FaCloudUploadAlt, FaDownload, FaHome, FaRegCalendarAlt, FaTasks } from 'react-icons/fa';

export default function Aside({page, expanded}) {
  const [measure, setMeasuer] = useState([]);
  const location = useLocation();
  const assetBaseUrl = process.env.PUBLIC_URL;
  const urlParams = new URLSearchParams(window.location.search);
  const searchParams = urlParams.get('num');
  const [activeSubmenu, setActiveSubmenu] = useState(`submenu_${searchParams}`);
  const [isMeasureMenuOpen, setIsMeasureMenuOpen] = useState(null);
  const { userData } = useContext(UserContext)

  const handleActiveSubmenu = (menu) => {
    setActiveSubmenu(menu);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(config.urlApi + '/measure');
        setMeasuer(res.data);
  
      } catch (err) {
        console.log(err.meassge)
      }
    }
    fetchData();
  }, []);

  const isPathActive = (paths = []) => paths.some((item) => location.pathname.toLowerCase().startsWith(item.toLowerCase()));
  const defaultMeasureExpanded = expanded || isPathActive(['/measure', '/measuredetail', '/measureresults']);
  const isMeasureExpanded = isMeasureMenuOpen === null ? defaultMeasureExpanded : isMeasureMenuOpen;

  const handleMeasureToggle = () => {
    setIsMeasureMenuOpen((prev) => {
      if (prev === null) return !defaultMeasureExpanded;
      return !prev;
    });
  };

  const closeSidebarOnMobile = () => {
    if (window.innerWidth <= 991.98) {
      const appRoot = document.querySelector('.app');
      appRoot?.classList.remove('sidenav-toggled');
    }
  };

  return (
    <aside className="app-sidebar app-theme-sidebar">
      <div className="app-sidebar__topbar d-flex d-lg-none">
        <button
          type="button"
          className="btn btn-link app-sidebar__toggle"
          data-toggle="sidebar"
          aria-label="ปิดเมนู"
        >
          <FaBars />
        </button>
      </div>
      <Link className="app-sidebar__brand" to="/" onClick={closeSidebarOnMobile}>
        <span className="app-sidebar__brand-kicker">CMU Landscape</span>
        <img src={`${assetBaseUrl}/img/brand/logo.png`} alt="CMU Landscape" />
        <span className="app-sidebar__brand-caption">Net Zero Workspace</span>
      </Link>
      <div className="app-sidebar__divider"></div>
      <ul className="side-menu">
        {userData.campusID === 'CT' ? (
          <>
           <li>
              <Link className={`side-menu__item ${location.pathname === '/' ? "active" : ""}`} to="/" onClick={closeSidebarOnMobile}><span className="side-menu__icon"><FaHome /></span><span className="side-menu__label">หน้าแรก</span></Link>
            </li>
            <li>
              <Link className={`side-menu__item ${isPathActive(['/activitydata', '/watertreatmentplants']) ? "active" : ""}`} to="/ActivityData" onClick={closeSidebarOnMobile}><span className="side-menu__icon"><BiSolidFactory /></span><span className="side-menu__label">โรงบำบัด</span></Link>
            </li>
          </>
        ) : (
          <>
            <li>
              <Link className={`side-menu__item ${location.pathname === '/' ? "active" : ""}`} to="/" onClick={closeSidebarOnMobile}><span className="side-menu__icon"><FaHome /></span><span className="side-menu__label">หน้าแรก</span></Link>
            </li>
            <li>
              <Link className={`side-menu__item ${isPathActive(['/activitydata', '/activitydetail']) ? "active" : ""}`} to="/Activitydata" onClick={closeSidebarOnMobile}><span className="side-menu__icon"><FaCloudUploadAlt /></span><span className="side-menu__label">กรอกข้อมูลก๊าซเรือนกระจก</span></Link>
            </li>
            <li className={`slide ${isMeasureExpanded ? "is-expanded" : ""}`}>
              <button type="button" className={`side-menu__item side-menu__button ${isPathActive(['/measure', '/measuredetail', '/measureresults']) ? "active" : ""}`} data-toggle="slide" onClick={handleMeasureToggle}><span className="side-menu__icon"><FaTasks /></span><span className="side-menu__label side-menu__label--two-line">กรอกข้อมูลมาตรการ</span><i className="angle fa fa-angle-right"></i></button>
              <ul className="slide-menu">
                {measure.map((item, index) => (
                  <li key={index}>
                    <Link to={`/measure?name=${encodeURIComponent(item.name)}&num=${encodeURIComponent(item.id)}`} className={`slide-item submenu-slide-items ${activeSubmenu === `submenu_${item.id}` ? "active" : ""}`} onClick={() => {
                      handleActiveSubmenu(`submenu_${item.id}`)
                      closeSidebarOnMobile()
                    }} title={item.name}>
                      <span className="slide-item__label">{item.name}</span>
                    </Link>
                  </li>
                ))}
                <li>
                  <Link className={`slide-item submenu-slide-items ${page === "measureResults" ? "active" : ""}`} to="/measureResults" onClick={closeSidebarOnMobile}><span className="slide-item__label">สรุปผลมาตรการ</span></Link>
                </li>
              </ul>
            </li>
            <li>
              <Link className={`side-menu__item ${isPathActive(['/downloadfile']) ? "active" : ""}`} to="/downloadfile" onClick={closeSidebarOnMobile}><span className="side-menu__icon"><FaDownload /></span><span className="side-menu__label">ดาวน์โหลดเอกสาร</span></Link>
            </li>
          </>
        )}
        
      </ul>
    </aside>
  )
}
